// ============================================================
//  src/app/init.js — Bootstrap principal de la aplicación
// ============================================================

import { iniciarObservadorAuth } from '../auth.js';
import { inicializarIdioma } from '../i18n.js';
import { inicializarEmailJS } from '../emails.js';
import { registrarTodosLosEventos } from './bindings.js';
import { logInfo } from '../core/logger.js';
import { registrarCallbackCambioEdiciones } from '../firestore.js';
import { actualizarPerfilPublico } from '../public-profile.js';
import { renderizarDashboard } from '../dashboard.js';
import { getPerfilActual } from '../perfil.js';
import { auth } from '../firebase.js';

export function inicializarAplicacion() {
  inicializarIdioma();
  inicializarEmailJS();
  registrarTodosLosEventos();
  iniciarObservadorAuth();

  registrarCallbackCambioEdiciones((ediciones) => {
    const uid = auth.currentUser?.uid;
    renderizarDashboard(ediciones, uid);
    const perfil = getPerfilActual();
    if (perfil?.indicativoOperador && uid) {
      actualizarPerfilPublico(uid, perfil, ediciones).catch(console.error);
    }
  });

  logInfo('App', 'Gestor de Concursos v2.0 iniciado.');
}
